module.exports = __webpack_public_path__ + "static/media/orion_homepage.24a8bc6c.png";